/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Gbp_Oauth_OkInputs */

const cs_integrations_gbp_oauth_ok = /** @type {(inputs: Integrations_Gbp_Oauth_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Business Profile propojeno.`)
};

const en_integrations_gbp_oauth_ok = /** @type {(inputs: Integrations_Gbp_Oauth_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Business Profile connected.`)
};

/**
* | output |
* | --- |
* | "Google Business Profile connected." |
*
* @param {Integrations_Gbp_Oauth_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_gbp_oauth_ok = /** @type {((inputs?: Integrations_Gbp_Oauth_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Gbp_Oauth_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_gbp_oauth_ok(inputs)
	return cs_integrations_gbp_oauth_ok(inputs)
});